import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Bell, Mail, MessageSquare, Users } from 'lucide-react';

const NotificationsSettings = () => {
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [assessmentAlerts, setAssessmentAlerts] = useState(true);
  const [teamUpdates, setTeamUpdates] = useState(false);
  const [weeklyReport, setWeeklyReport] = useState(true);
  const [marketingEmails, setMarketingEmails] = useState(false);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight">Notifications</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Control how you receive notifications and updates
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <Mail className="h-5 w-5" />
            Email Notifications
          </CardTitle>
          <CardDescription>
            Manage your email notification preferences
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label htmlFor="email-all">All Email Notifications</Label>
              <p className="text-sm text-muted-foreground">
                Receive all email notifications
              </p>
            </div>
            <Switch 
              id="email-all"
              checked={emailNotifications}
              onCheckedChange={setEmailNotifications}
            />
          </div>

          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label htmlFor="assessments">Assessment Completions</Label>
              <p className="text-sm text-muted-foreground">
                Get notified when candidates complete assessments
              </p>
            </div>
            <Switch 
              id="assessments"
              checked={assessmentAlerts}
              onCheckedChange={setAssessmentAlerts}
              disabled={!emailNotifications}
            />
          </div>

          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label htmlFor="team">Team Updates</Label>
              <p className="text-sm text-muted-foreground">
                Receive updates about team member activities
              </p>
            </div>
            <Switch 
              id="team"
              checked={teamUpdates}
              onCheckedChange={setTeamUpdates}
              disabled={!emailNotifications}
            />
          </div>

          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label htmlFor="weekly">Weekly Summary</Label>
              <p className="text-sm text-muted-foreground">
                Get a weekly summary of your dashboard activity
              </p>
            </div>
            <Switch 
              id="weekly"
              checked={weeklyReport}
              onCheckedChange={setWeeklyReport}
              disabled={!emailNotifications}
            />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <MessageSquare className="h-5 w-5" />
            Marketing & Updates
          </CardTitle>
          <CardDescription>
            Opt in to receive product updates and tips
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label htmlFor="marketing">Product Updates</Label>
              <p className="text-sm text-muted-foreground">
                Receive news about new features and improvements
              </p>
            </div>
            <Switch 
              id="marketing"
              checked={marketingEmails}
              onCheckedChange={setMarketingEmails}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotificationsSettings;